<template>
  <v-container class="input-text-size">
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-3 ma-3 pa-3">
          <export-form @export-queued="onExportQueued" />
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-3 ma-3 pa-3">
          <file-queue-table ref="queueTable" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ExportForm from '@/components/tax/MortgageCoProcessing/ExportForm.vue';
import FileQueueTable from '@/components/tax/MortgageCoProcessing/FileQueueTable.vue';

export default {
  name: 'MortgageCoExport',
  components: {
    ExportForm,
    FileQueueTable,
  },
  methods: {
    onExportQueued() {
      // Refresh the queue table when a new export is queued
      if (this.$refs.queueTable) {
        this.$refs.queueTable.loadQueue();
      }
    },
  },
};
</script>

<style scoped>
</style>
